export enum AccreditationStatusEnum {
  IN_REVIEW = 'in_review',
  ACCREDITED = 'accredited',
  NOT_ACCREDITED = 'not_accredited',
}
